import surveyModule from 'common/apps/modules/survey';

import createApp from '../../core/createApp';
import notificationsModule from '../../modules/notifications';
import modalsModule from '../../modules/modals';

import { GlobalAppType } from './types';

const createGlobalApp = (type: GlobalAppType) =>
  createApp(
    [
      notificationsModule,
      modalsModule,
      ...(APP_NAME === 'affiliates' && type === GlobalAppType.MainApp
        ? [surveyModule]
        : []),
    ],
    {
      isGlobal: true,
    },
  );

export default createGlobalApp;
